export function stopClickThrough<E extends { stopPropagation: () => void; preventDefault: () => void }>(event: E) {
  event.stopPropagation();
  event.preventDefault();
}
